import { Directive } from '@angular/core';
import { ModelBase } from './../../model/model-base';
import { DataService, IModel } from './../../service/base/data.service';
import { FormComponentBase } from './form-component.base';

/** Modern base implementation - Has the service as first generic argument (from which all model types can be infered). */
@Directive()
export abstract class FormComponentBase2<
  TDataService extends DataService<TModel, any, IModel>,
  TModel extends ModelBase = TDataService extends DataService<infer U, any, IModel> ? U : ModelBase,
  TModelCreate extends TDataService extends DataService<TModel, infer U, IModel> ? U : any = TDataService extends DataService<
    TModel,
    infer U,
    IModel
  >
    ? U
    : TModel,
  TModelUpdate extends TDataService extends DataService<TModel, TModelCreate, infer U> ? U : IModel = TDataService extends DataService<
    TModel,
    TModelCreate,
    infer U
  >
    ? U
    : TModel,
> extends FormComponentBase<TModel, TDataService, TModelCreate, TModelUpdate> {}
